<template>
  <div>
    <LoadingOverlay active />
  </div>
</template>

<script>
export default {
  created() {
    this.$auth.loginWithRedirect();
  },
};
</script>
